/* eslint-disable */
import axios from '../../../shared/utils/axios-init';


/* eslint-disable */
const initialState = {
  requestsData: [],
  baseCurrencies: [],
  quoteCurrencies: [],
  statusData: [],
  requestData: [],
};

const getters = {
  getRequestsData: state => state.requestsData,
  getBaseCurrencies: state => state.baseCurrencies,
  getQuoteCurrencies: state => state.quoteCurrencies,
  getStatusData: state => state.statusData,
  getRequestData: state => state.requestData,
};

const mutations = {
  setRequestsData(state, requests) {
    state.requestsData = requests;
  },
  setRequestData(state, request) {
    state.requestData = request;
  },
  setBaseCurrencies(state, data) {
    state.baseCurrencies = data;
  },
  setQuoteCurrencies(state, data) {
    state.quoteCurrencies = data;
  },
  setStatusData(state, data) {
    state.statusData = data;
  },
  deleteRequest(state, requestId) {
    const requestIndex = state.requestsData.findIndex((element) => {
      if (element.order_id === requestId) {
        return true;
      }
      return false;
    });
    state.requestsData.splice(requestIndex, 1);
  },
};

const actions = {
  async fetchAccountRequestsData({ commit, dispatch, rootState }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const lang = localStorage.getItem('language');
      const data = await axios.post('/cabinet/orders', JSON.stringify({ lang }), { headers: { Authorization: `Bearer ${token}` } });
      const userRequestsData = data.data.orders;
      const baseCurrenciesData = data.data.base_currencies;
      const quoteCurrenciesData = data.data.quoted_currencies;
      const statusesData = data.data.order_statuses;

      // forming alphabetically sorted arrays of currencies codes and statuses
      const baseCurrenciesArr = ['All'];
      const quoteCurrenciesArr = ['All'];
      const ordersStatusesArr = ['All'];
      baseCurrenciesData
      .sort((a, b) => {
       if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
       if (a.code.toLowerCase() > b.code.toLowerCase()) return 1; 
       return 0;
      })
      .forEach((el) => {
        baseCurrenciesArr.push(el.code);
      });
      quoteCurrenciesData
      .sort((a, b) => {
       if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
       if (a.code.toLowerCase() > b.code.toLowerCase()) return 1; 
       return 0;
      })
      .forEach((el) => {
        quoteCurrenciesArr.push(el.code);
      });
      statusesData
      .sort((a, b) => {
       if (a.status_name.toLowerCase() < b.status_name.toLowerCase()) return -1;
       if (a.status_name.toLowerCase() > b.status_name.toLowerCase()) return 1; 
       return 0;
      })
      .forEach((el) => {
        ordersStatusesArr.push(el.status_name);
      });

      commit('setRequestsData', userRequestsData);
      commit('setBaseCurrencies', baseCurrenciesArr);
      commit('setQuoteCurrencies', quoteCurrenciesArr);
      commit('setStatusData', ordersStatusesArr);
    } catch (err) {
      /* eslint-disable */
      console.log(err)
    }
  },
  async getRequestData({ commit, dispatch, rootState }, requestId) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/cabinet/orders/info', JSON.stringify(requestId), { headers: { Authorization: `Bearer ${token}` } });
      const userRequestData = data.data.deals;
      
      commit('setRequestData', userRequestData);
    } catch (err) {
      /* eslint-disable */
      console.log(err)
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/requests.js